import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import Cookies from "js-cookie";
// eslint-disable-next-line import/default
import React from "react";
// eslint-disable-next-line import/default
import ReactDOM, { render } from "react-dom";
import AccessibilityWarningStyles from "./AccessibilityWarningStyles.module.scss";
import { getRuntimeEnvironment, isNotUndefined, isUndefined, nonAaAxeViolationsIdSet } from "./FunctionsCore";
const styles = AccessibilityWarningStyles;
let hasRunGetRuntimeEnvironment = false;
let runtimeEnvironment = void 0;
let runtimeEnvironmentIsUndefined = true;
const addToRenderableData = (re, m) => ({
    "data": Object.assign(Object.assign({}, re.data), m),
    "identifier": re.identifier
});
const renderIdentifierGeneric = (functionComponent, parameter) => {
    if (!hasRunGetRuntimeEnvironment) {
        hasRunGetRuntimeEnvironment = true;
        runtimeEnvironment = getRuntimeEnvironment();
        runtimeEnvironmentIsUndefined = isUndefined(runtimeEnvironment);
    }
    const $identifier = $(`.${parameter.identifier}`);
    // Hack to get around TypeScript/invalid hook call warning (https://reactjs.org/warnings/invalid-hook-call-warning.html)
    const FunctionComponentAny = functionComponent;
    // TODO Restore StrictMode
    // https://levelup.gitconnected.com/react-18-the-trickiness-of-useeffect-fadfa65fa4b4
    const renderIntoIdentifier = () => render(_jsx(FunctionComponentAny, Object.assign({}, parameter.data)), $identifier[0]);
    if (runtimeEnvironmentIsUndefined) {
        renderIntoIdentifier();
    }
    else {
        import("@axe-core/react").then(re => {
            let totalAaViolations = 0;
            let $div = void 0;
            re.default(React, ReactDOM, 1000, void 0, void 0, (ax) => {
                const aaViolations = ax.violations.filter(axeR => !nonAaAxeViolationsIdSet.has(axeR.id));
                for (const axeR of aaViolations) {
                    window.console.error(`Accessibility violation - ${axeR.impact} - ${axeR.description}`);
                    for (const no of axeR.nodes) {
                        window.console.error("target", no.target);
                        window.console.error("HTML", no.html);
                        for (const st of no.target) {
                            $(st)
                                .addClass(styles.accessibilityViolation)
                                .attr("data-accessibility-violation-help-url", axeR.helpUrl)
                                .attr("data-accessibility-violation-id", axeR.id);
                        }
                    }
                }
                const aaViolationsLength = aaViolations.length;
                if (aaViolationsLength > 0) {
                    totalAaViolations += aaViolationsLength;
                    if (isNotUndefined($div)) {
                        $div.remove();
                    }
                    const $newDiv = $("<div></div>")
                        .addClass(styles.rightWarning)
                        .text(`${totalAaViolations} WCAG AA accessibility violations detected in React code, check the console`);
                    const removeDiv = () => $newDiv.remove();
                    const $button = $("<button></button>")
                        .addClass(styles.closeButton)
                        .attr("type", "button")
                        .on("click", () => removeDiv())
                        .text("Close");
                    const $buttonTwo = $("<button></button>")
                        .addClass(styles.closeButton)
                        .attr("type", "button")
                        .on("click", () => {
                        removeDiv();
                        Cookies.set("hideAccessibilityWarnings", "true", {
                            // One hour from now
                            "expires": new Date(Date.now() + (60 * 60 * 1000)),
                            "path": "/"
                        });
                    })
                        .text("Close and hide warnings for an hour");
                    const $buttonWrapper = $("<div></div>").addClass(styles.buttonWrapper);
                    $buttonWrapper.append($button).append($buttonTwo);
                    $newDiv.append($buttonWrapper);
                    $("body").append($newDiv);
                    $div = $newDiv;
                }
            });
            renderIntoIdentifier();
        });
    }
};
const classCombinerFromPrefix = (prefix) => (re, t) => {
    const generatedClassName = re[t];
    // https://stackoverflow.com/questions/448981/which-characters-are-valid-in-css-class-names-selectors/449000#449000
    return [`z_${prefix}_${t}`, generatedClassName];
};
export { addToRenderableData, classCombinerFromPrefix, renderIdentifierGeneric };
